import { cn } from "@Core/Helpers";
import React, { ComponentProps } from 'react';
import ReactModal from 'react-modal';

ReactModal.setAppElement('#modal');

if (!ReactModal.defaultStyles.overlay) {
    ReactModal.defaultStyles.overlay = {};
}

ReactModal.defaultStyles.overlay.backgroundColor = 'rgba(0, 0, 0, 0.5)';
ReactModal.defaultStyles.overlay.zIndex = 1080;
ReactModal.defaultStyles.overlay.overflow = 'auto';

const sizes = {
    xs: 'sm:max-w-[256px]',
    sm: 'sm:max-w-[300px]',
    md: 'sm:max-w-[500px]',
    lg: 'sm:max-w-[800px]',
    xl: 'sm:max-w-[1140px]',
    '2xl': 'sm:max-w-[1280px]',
};

export type ModalSize = keyof typeof sizes;

const ModalFrame =  (
    { className, size = 'md', ...props }: ComponentProps<typeof ReactModal> & { size:ModalSize }
) => {
    return <ReactModal
        className={cn(
            'flex flex-col border bg-white mx-auto relative sm:my-10 outline-none sm:rounded-sm w-full',
            'h-full sm:h-auto',
            sizes[size] ?? '',
            className,
        )}
        {...props}
    />;
};

ModalFrame.displayName = 'ModalFrame';

export default ModalFrame;
